import * as React from 'react';
import { Layer, Source } from 'react-map-gl';
import turf from 'turf';
const RouteLine = (props) => {
    const { coordinates, id, isDashed = false, opacity = 0.75, routeColor } = props;
    const line = turf.lineString(coordinates);
    return (React.createElement(React.Fragment, { key: id },
        React.createElement(Source, { key: id, id: id, type: "geojson", data: line }),
        React.createElement(Layer, { id: id, type: "line", source: id, layout: {
                'line-cap': 'round',
                'line-join': 'round'
            }, paint: {
                'line-color': routeColor,
                'line-dasharray': isDashed ? [1, 2] : [1],
                'line-opacity': opacity,
                'line-width': 4
            } })));
};
RouteLine.displayName = 'Route';
export { RouteLine };
